import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import { IssueStatus, Status, Type } from '@/entities/todo';
import { IssuePriority } from '@/entities/issue';
import * as q from '@/services/api/request/query';

export interface TodoQuery extends PaginatableQuery, SortableQuery {
  search: string;
  assignee: number[];
  assigneeOrInspectionUser?: number[];
  user?: number[];
  entityItem: number[];
  status: Status[];
  issueStatus: IssueStatus[];
  priority: IssuePriority[];
  updatedAtStart: Date | null;
  updatedAtEnd: Date | null;
  overdue: boolean | null;
  woAssigneeOrDeadline?: boolean;
  type?: Type | null;
  questions?: number[];
  lazyPagination?: number;
}

export const encodeTodoQuery = (query: TodoQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  entityItem: q.numbers(query.entityItem),
  status: q.numericEnums(query.status),
  issueStatus: q.numericEnums(query.issueStatus),
  priority: q.numericEnums(query.priority),
  updatedAtStart: q.nullableDate(query.updatedAtStart),
  updatedAtEnd: q.nullableDate(query.updatedAtEnd),
  assignee: q.numbers(query.assignee),
  assigneeOrInspectionUser: q.numbers(query.assigneeOrInspectionUser ?? []),
  user: q.numbers(query.user ?? []),
  ...encodeSortableQuery(query),
  overdue: q.nullableBoolean(query.overdue),
  woAssigneeOrDeadline: query.woAssigneeOrDeadline ? q.boolean(query.woAssigneeOrDeadline) : '',
  type: q.nullableString(query.type ? query.type.toString() : null),
  questions: q.numbers(query.questions ? query.questions : []),
  lazyPagination: q.number(query.lazyPagination ?? 0),
});
